import { z } from "zod";
import { EventParticipantIdPublicSchema } from "./branded-id.schemas.js";
import { ParticipantPhotoUrlSchema } from "./participant-photo-url.schemas.js";

/**
 * Roster row at the generic (event-owner) tier: enough to render someone in a
 * picker, with no contact details and no internal id — the admin tier extends it.
 * `photoUrl` may be an `evt-participant-photo://` placeholder the client resolves
 * against the event — a shape the brand accepts.
 */
export const EventParticipantRosterEntrySchema = z.object({
  participantIdPublic: EventParticipantIdPublicSchema,
  fullName: z.string(),
  title: z.string().nullable(),
  photoUrl: ParticipantPhotoUrlSchema.nullable(),
  vip: z.boolean(),
});

export const EventParticipantRosterSchema = z.object({
  participants: z.array(EventParticipantRosterEntrySchema),
});

export type EventParticipantRosterEntry = z.infer<
  typeof EventParticipantRosterEntrySchema
>;
export type EventParticipantRoster = z.infer<
  typeof EventParticipantRosterSchema
>;
